export default {
  name: "Heart",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M16 28.77c-.3 0-.58-.13-.77-.36-1.16-1.4-3.02-2.78-4.98-4.24-4.71-3.5-10.56-7.86-8.99-14.85.75-3.31 3.67-6.01 6.79-6.29 1.84-.17 5.13.38 7.87 5.31 2.36-4.81 5.62-5.43 7.5-5.32 3.34.19 6.55 2.96 7.3 6.3 1.55 6.89-4.24 11.21-8.89 14.68-2.03 1.52-3.95 2.95-5.06 4.39-.18.24-.47.39-.77.39.01-.01.01-.01 0-.01zM8.62 5c-.13 0-.26.01-.39.02-2.26.2-4.46 2.28-5.01 4.74-1.29 5.72 3.55 9.32 8.23 12.81 1.68 1.25 3.28 2.44 4.53 3.7 1.25-1.32 2.92-2.57 4.67-3.87 4.62-3.45 9.4-7.01 8.13-12.63-.56-2.48-3.01-4.61-5.47-4.75-2.71-.17-4.95 2.01-6.37 6.09a1 1 0 0 1-.91.67.99.99 0 0 1-.95-.61C13.39 7.17 11.11 5 8.62 5zM2.24 9.54z",
  },
}
